import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-srm-ticket-list-mobile-skeleton',
  templateUrl: './srm-ticket-list-mobile-skeleton.component.html',
  styleUrl: 'srm-ticket-list-mobile-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class SrmTicketListMobileSkeletonComponent {
}
